'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('stations', {
      url: '/admin/stations',
      template: '<stations></stations>'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/stations/stations.routes.js